var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"a-text-link",on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }